import {getCountry} from '../store/util';

const country = getCountry();

export const env = {
  NODE_ENV: 'development',
  CLIENT_ID: 'neodash_qa',
  URL: {
    HOST: `http://neodash.refactory.neogig.com.${country}`,
    NEOGIG: `http://qa.neogig.com.${country}`,
    NEOGIG_API: `http://neogig-api.refactory.neogig.com.${country}/api/v1`,
    NEOGIG_IMAGE: `http://qa.neogig.com.${country}/static/images`,
    NEODASH_API: `http://neodash-api.refactory.neogig.com.${country}`,
    REPORT_VIEWER: `http://reportviewer.refactory.neogig.com.${country}`,
    CTRL_PANEL_API: `http://cp-api.refactory.neogig.com.${country}`,
    IDENTITY_SERVER: `http://identity-server.refactory.neogig.com.${country}`,
    WEBSOCKET: 'ws://neodash-api.refactory.neogig.com.${country}/WsSocketHandler.ashx',
    PBIURL: `https://app.powerbi.com/`,
  }
};
